<template>
  <div v-show="isVisible" :class="['wrapper', 'wrap-left', 'h-100', { 'open-modal-left': isOpen }]">
    <div class="modalBody bg-white w-100 h-100">
      <div class="modalHeader">
        <div class="title-section">{{ $translate("ETCeresCoconut::Template.etcNewsletterSectionTitel") }}</div>
        <div class="close-modal-button" @click="startClose"></div>
      </div>

      <div class="modalContent">
        <ul class="newsletter-bullet-points">
          <li v-html="$translate('ETCeresCoconut::Template.etcNewsletterBulletPoint1')"></li>
          <li v-html="$translate('ETCeresCoconut::Template.etcNewsletterBulletPoint2')"></li>
          <li v-html="$translate('ETCeresCoconut::Template.etcNewsletterBulletPoint3')"></li>
          <li v-html="$translate('ETCeresCoconut::Template.etcNewsletterBulletPoint4')"></li>
        </ul>

        <h4 class="leftmodal-header">
          {{ $translate("ETCeresCoconut::Template.etcNewsletterAnmeldungText") }}
        </h4>
        <hr>

        <lazy-hydrate when-idle>
          <newsletter-input :email-folder="emailFolderId" />
        </lazy-hydrate>
      </div>

      <div class="modalFooter">
        <div class="small mt-2">
          {{ $translate("ETCeresCoconut::Template.etcNewsletterInformationText") }}
        </div>
        <div class="small mt-2">
          {{ $translate("Ceres::Template.newsletterIsRequiredFootnote") }}
          {{ $translate("Ceres::Template.newsletterIsRequired") }}
        </div>
      </div>
    </div>

    <div class="overlay" @click="startClose"></div>
  </div>
</template>

<script>
export default {
  name: "NewsletterModal",

  props: {
    emailFolderId: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      isVisible: false,
      isOpen: false
    };
  },
  mounted() {
    this.$root.$on("open-newsletter-modal", this.showModal);
  },
  beforeDestroy() {
    this.$root.$off("open-newsletter-modal", this.showModal);
  },

  methods: {
    showModal() {
      if (this.isVisible) return;

      this.isVisible = true;
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.isOpen = true;
        });
      });
    },

    startClose() {
      this.isOpen = false;
      setTimeout(() => {
        this.isVisible = false;
        this.$emit("close");
      }, 300);
    }
  }
};
</script>

